import React from 'react';

import { StoreManagementModule } from '../stores';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryStoresModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.store', action: 'read' },
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <StoreManagementModule />
    </InventoryPermissionGuard>
  );
}